import { ApiStudentRequest, request } from '../utils'
import { useAuthQuery } from './auth'
import { GetLanguageProficiencyByIdResponse } from '@backend/students-api/routes/documents/language-proficiencies/{languageProficiencyId}/GET/types'

type GetLanguageProficiencyProps = {
  studentId: string
  languageProficiencyId: string
}

export function useGetLanguageProficiency(props: GetLanguageProficiencyProps) {
  const { data, isLoading, isFetching } = useAuthQuery(
    ['language-proficiency', props.languageProficiencyId],
    async () => await getLanguageProficiency(props.languageProficiencyId),
    {
      enabled: !!props.studentId && !!props.languageProficiencyId,
    },
  )

  return {
    languageProficiencyRecord: data?.data,
    isLoadingLanguageProficiency: isLoading,
    isFetchingLanguageProficiency: isFetching,
  }
}

export async function getLanguageProficiency(languageProficiencyId?: string) {
  return request<GetLanguageProficiencyByIdResponse>(
    new ApiStudentRequest(`/documents/language-proficiencies/${languageProficiencyId}`, {
      method: 'GET',
    }),
    {
      isExpectedResponse: (res): res is GetLanguageProficiencyByIdResponse => res as boolean,
    },
  )
}
